const PhoneMask = () => {
  const phoneInputs = [
    ...document.querySelectorAll("input[type='tel']"),
    ...document.querySelectorAll("input[name='Phone']")
  ];

  phoneInputs.forEach((phoneInput) => {
    phoneInput.addEventListener('input', function (event) {
      let input = event.target.value.replace(/\D/g, ''); 
      let formattedInput = '+' + input;  
      
      event.target.value = formattedInput;
    });
  });
}

export default PhoneMask;
